<template>
  <div class="Ftim-box" v-if="infolist">
    <div class="Ftim-bt">
      <span>至德-</span>个人中心
      <i></i>
    </div>

    <div class="Current-box">
      <div class="Currbj-left"></div>

      <all-left></all-left>

      <div class="Current-right">
        <div class="" v-if="isshow == 0">
          <div class="Current-topic">
            <div class="Current-name">我的发布</div>
            <div class="Current-unread" @click="Gorele('', 1)">发布</div>
          </div>
          <div class="Current-cent">
            <div
              class="Current-list"
              v-for="(item, index) in infolist"
              :key="index"
            >
              <div class="Current-pic">
                <img v-if="item.images.length > 0" :src="item.images[0].url" />
                <img v-else src="" />
              </div>
              <div class="Current-info">
                <div class="Current-title">{{ item.title }}</div>
                <div class="">
                  <span class="Current-bq">{{ item.type }}</span>
                  <span class="Current-yfb">{{ item.status }}</span>
                </div>
                <div class="Current-bot">
                  <div class="Current-time">{{ item.created_at }}</div>
                  <div class="">
                    <span class="Current-bianji" @click="Gorele(item.id, 2)"
                      >编辑</span
                    >
                    <span
                      class="Current-shanchu"
                      @click="Liedel(item.id, index)"
                      >删除</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="Ftim-more" @click="More" v-if="isgoto">加载更多</div>
          </div>
        </div>

        <div class="" v-if="isshow == 1">
          <div class="Current-topic">
            <div class="Current-name">发布</div>
          </div>
          <div class="Current-cent">
            <div class="reinfo-list">
              <i>*</i>
              <span>标题</span>
              <el-input
                class="reinfo-inp"
                type="text"
                v-model="listcent.title"
                placeholder="请输入姓名"
              ></el-input>
            </div>
            <div class="reinfo-list">
              <i>*</i>
              <span>信息类别</span>
              <el-select placeholder="请选择" v-model="listcent.type">
                <el-option
                  v-for="item in Degree"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="reinfo-jianjie">
              <i>*</i>
              <span>简介</span>
              <el-input
                class="reinfo-tare"
                type="textarea"
                :rows="3"
                placeholder="请输入简介限80字以内…"
                maxlength="80"
                v-model="listcent.intro"
              ></el-input>
            </div>

            <div class="reinfo-uppic">
              <div class="reinfo-uptop">
                <i>*</i>
                <span>缩略图</span>
                <b>最多上传5张图片，第一张为缩略图</b>
              </div>

              <div class="picture-box">
                <div class="picture-up" v-if="ruleForm.length < 5">
                  <el-upload
                    action=""
                    list-type="picture-card"
                    :before-upload="handleBeforeUpload"
                    :on-success="successHandle"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>

                <div class="picture-ever">
                  <div
                    class="picture-list"
                    v-for="(item, index) in ruleForm"
                    :key="index"
                  >
                    <img :src="item.url" />
                    <span @click="delpic(index)"></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="reinfo-jianjie bordnone">
              <i>*</i>
              <span>信息内容</span>
              <el-input
                class="reinfo-tare"
                type="textarea"
                :rows="6"
                placeholder="请输入内容，限制500字以内…"
                maxlength="500"
                v-model="listcent.content"
              ></el-input>
            </div>

            <div class="reinfo-but">
              <div class="reinfo-close" @click="Close()">取消</div>
              <div class="reinfo-ok" @click="Preserve()" v-if="buttype == 2">
                保存
              </div>
              <div class="reinfo-ok" @click="Submit()" v-if="buttype == 1">
                提交审核
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="Currbj-right"></div>
    </div>
  </div>
</template>
<script>
import AllLeft from "../../components/Personleft.vue"; //个人中心公用左侧
export default {
  components: {
    AllLeft,
  },
  data() {
    return {
      token: localStorage.pctoken, //获取token
      infolist: [],
      isshow: 0, //显示列表发布编辑
      page: 1, //当前页码
      isgoto: false, //是否显示加载更多
      listcent: {
        //发布编辑参数
        title: "",
        type: "",
        intro: "",
        images: [],
        content: "",
      },
      Degree: [
        {
          title: "寻亲",
          id: 0,
        },
        {
          title: "寻同学",
          id: 1,
        },
        {
          title: "寻朋友",
          id: 2,
        },
        {
          title: "寻战友",
          id: 3,
        },
      ], //联络友谊分类
      ruleForm: [],
    };
  },
  created() {
    this.getData();
  },
  mounted() {},
  methods: {
    //获取详情数据
    getData() {
      this.$layer.loading();
      this.$http
        .get("user/contact?page=" + this.page, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.$layer.closeAll("loading");
          if (res.data.code == 200) {
            this.infolist = this.infolist.concat(res.data.data.data);
            if (res.data.data.next_page_url != null) {
              this.isgoto = true;
              this.page += 1;
            } else {
              this.isgoto = false;
            }
          } else {
            this.$layer.msg(res.data.message);
          }
        });
    },

    //列表编辑
    Lieedit(id) {},
    //列表删除
    Liedel(id, index) {
      this.$layer.loading();
      this.$http
        .delete("user/contact/" + id, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.$layer.closeAll("loading");
          if (res.data.code == 200) {
            this.$layer.msg("删除成功");
            this.infolist.splice(index, 1);
          } else {
            this.$layer.msg(res.data.message);
          }
        });
    },

    //加载更多
    More() {
      this.getData();
    },

    //点击发布或编辑
    Gorele(getid, num) {
      if (num == 1) {
        this.isshow = 1;
        this.buttype = 1;
      } else if (num == 2) {
        this.$layer.loading();
        this.$http
          .get("contact/" + getid, {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          })
          .then((res) => {
            this.$layer.closeAll("loading");
            if (res.data.code == 200) {
              this.buttype = 2;
              let info = res.data.data;
              let istype = "";
              if (info.type == "寻亲") {
                istype = 0;
              } else if (info.type == "寻同学") {
                istype = 1;
              } else if (info.type == "寻朋友") {
                istype = 2;
              } else if (info.type == "寻战友") {
                istype = 3;
              }

              (this.listcent = {
                title: info.title,
                type: istype,
                intro: info.intro,
                images: info.images,
                content: info.content,
                id: info.id,
              }),
                (this.ruleForm = info.images);
              this.isshow = 1;
            } else {
              this.$layer.msg(res.data.message);
            }
          });
      }
    },

    //上传图片
    handleBeforeUpload(file) {
      const formData = new FormData();
      formData.append("img", file);
      this.uploadObject(formData);
      return false;
    },
    uploadObject(formData) {
      this.$layer.loading();
      this.$http
        .post("upload", formData, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then(this.successHandle)
        .catch(this.handleError);
    },
    successHandle(response) {
      this.$layer.closeAll("loading");
      this.ruleForm.push({ url: response.data.data.path });
    },

    //删除图片
    delpic(index) {
      this.ruleForm.splice(index, 1);
    },

    //取消发布和编辑
    Close() {
      this.isshow = 0;
      this.listcent = {
        //发布编辑参数
        title: "",
        type: "",
        intro: "",
        images: [],
        content: "",
      };
      this.ruleForm = [];
    },

    //保存
    Preserve() {

      if (!this.listcent.title) {
        this.$layer.msg("请输入标题");
        return;
      }

      if (this.listcent.type == "-1") {
        this.$layer.msg("请选择信息类别");
        return;
      }

      if (!this.listcent.intro) {
        this.$layer.msg("请输入简介");
        return;
      }

      if (this.ruleForm.length == 0) {
        this.$layer.msg("请上传缩略图");
        return;
      }

      if (!this.listcent.content) {
        this.$layer.msg("请输入信息内容");
        return;
      }

      this.$layer.loading();

      this.listcent.images = this.ruleForm;

      this.$http
        .put("user/contact", this.listcent, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.$layer.closeAll("loading");
          if (res.data.code == 200) {
            this.$layer.msg("保存成功");
            setTimeout(() => {
              this.isshow = 0;
              this.listcent = {
                //发布编辑参数
                title: "",
                type: "",
                intro: "",
                images: [],
                content: "",
              };
              this.ruleForm = [];
              this.infolist = [];
              this.getData();
            }, 800);
          } else {
            this.$layer.msg(res.data.message);
          }
        });
    },
    //发布
    Submit() {

      if (!this.listcent.title) {
        this.$layer.msg("请输入标题");
        return;
      }

      if (!this.listcent.type || this.listcent.type == "-1") {
        this.$layer.msg("请选择信息类别");
        return;
      }

      if (!this.listcent.intro) {
        this.$layer.msg("请输入简介");
        return;
      }

      if (this.ruleForm.length == 0) {
        this.$layer.msg("请上传缩略图");
        return;
      }

      if (!this.listcent.content) {
        this.$layer.msg("请输入信息内容");
        return;
      }

      this.$layer.loading();
      this.listcent.images = this.ruleForm;

      this.$http
        .post("contact", this.listcent, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.$layer.closeAll("loading");
          if (res.data.code == 200) {
            this.$layer.msg("发布成功");
            setTimeout(() => {
              this.isshow = 0;
              this.listcent = {
                //发布编辑参数
                title: "",
                type: "",
                intro: "",
                images: [],
                content: "",
              };
              this.ruleForm = [];
              this.infolist = [];
              this.getData();
            }, 800);
          } else {
            this.$layer.msg(res.data.message);
          }
        });
    },
  },
};
</script>
<style scoped>
.Ftim-box {
  background: url(../../../public/images/dysjbjt.png) top no-repeat;
  margin-bottom: 20px;
}

.Ftim-bt {
  width: 1200px;
  margin: 72px auto 0;
  font-weight: bold;
  font-size: 48px;
  color: #333;
  line-height: 48px;
}

.Ftim-bt span {
  color: #d71e1c;
}

.Ftim-bt i {
  display: block;
  width: 48px;
  height: 4px;
  background: #d71e1c;
  margin-top: 30px;
}

.Current-box {
  width: 1200px;
  margin: 80px auto 0;
  display: flex;
}

.Currbj-left {
  width: 30px;
  height: 790px;
  background: url(../../../public/images/grleft.png) bottom no-repeat;
}

.Currbj-right {
  width: 30px;
  height: 790px;
  background: url(../../../public/images/grright.png) bottom no-repeat;
}

.Current-right {
  flex: 1;
  background: #fff;
  border-left: 1px solid #d8d8d8;
  padding: 40px 0 0 40px;
  height: 700px;
  overflow: auto;
  border-radius: 0 20px 0 0;
}

.Current-cent {
  max-height: 640px;
  overflow: auto;
}

.Current-cent::-webkit-scrollbar {
  width: 2px;
  height: 4px;
  margin-top: 10px;
}

.Current-cent::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.Current-cent::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.Current-topic {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #d8d8d8;
  margin-right: 40px;
}

.Current-name {
  font-weight: bold;
  font-size: 24px;
  color: #333333;
}

.Current-unread {
  width: 80px;
  height: 28px;
  background: linear-gradient(139deg, #ed403c 0%, #d71e1c 100%);
  border-radius: 14px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}

.Current-list {
  display: flex;
  width: 760px;
  border-radius: 6px;
  border: 1px solid #d8d8d8;
  margin-top: 20px;
  padding: 20px;
}

.Current-pic {
  width: 165px;
  height: 120px;
  border-radius: 6px;
}

.Current-pic img {
  width: 165px;
  height: 120px;
  border-radius: 6px;
}

.Current-info {
  flex: 1;
  margin-left: 20px;
}

.Current-title {
  overflow: hidden;
  /* 溢出部分进行隐藏 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /* 盒模型元素从顶部向底部垂直排列子元素 */
  -webkit-line-clamp: 1;
  /* 显示两行 */
  text-overflow: ellipsis;
}

.Current-bq {
  display: inline-block;
  background: linear-gradient(137deg, #ffb73a 0%, #fe6809 100%);
  border-radius: 10px;
  line-height: 20px;
  text-align: center;
  padding: 0 11px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  margin-top: 15px;
}

.Current-yfb {
  display: inline-block;
  background: linear-gradient(137deg, #56d32e 0%, #33a30f 100%);
  border-radius: 10px;
  line-height: 20px;
  text-align: center;
  padding: 0 11px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  margin-left: 10px;
  margin-top: 15px;
}

.Current-bot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 38px;
}

.Current-time {
  font-size: 16px;
  color: #999999;
}

.Current-bianji {
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  padding-left: 20px;
  background: url(../../../public/images/bianjbjt.png) left no-repeat;
  background-size: 16px 17px;
  line-height: 26px;
  cursor: pointer;
}

.Current-shanchu {
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  padding-left: 20px;
  background: url(../../../public/images/shanchubjt.png) left no-repeat;
  background-size: 16px 17px;
  line-height: 26px;
  cursor: pointer;
  margin-left: 20px;
}

.Ftim-more {
  width: 180px;
  height: 36px;
  background: #f2f2f2;
  border-radius: 18px;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 36px;
  text-align: center;
  margin: 40px auto 0;
  cursor: pointer;
}

.reinfo-list {
  display: flex;
  border-bottom: 1px dotted #d8d8d8;
  align-items: center;
  margin-top: 20px;
  padding-bottom: 16px;
}

.reinfo-list i {
  width: 6px;
  color: #e2195c;
}

.reinfo-list span {
  width: 110px;
  font-size: 16px;
  color: #333;
  margin-left: 2px;
}

.reinfo-inp {
  width: 90%;
}

::v-deep .reinfo-list .reinfo-inp .el-input__inner {
  width: 90%;
  font-size: 16px;
  font-family: ArialMT;
  color: #666666;
  border: none;
  padding: 0;
}

::v-deep .reinfo-list .el-input--suffix .el-input__inner {
  border: none;
  background: #f2f2f2;
  border-radius: 16px;
}

.reinfo-jianjie {
  display: flex;
  border-bottom: 1px dotted #d8d8d8;
  margin-top: 20px;
  padding-bottom: 16px;
}

.reinfo-jianjie i {
  width: 6px;
  color: #e2195c;
}

.reinfo-jianjie span {
  width: 116px;
  display: block;
  font-size: 16px;
  color: #333;
  margin-left: 2px;
}

.reinfo-tare {
  width: 90%;
}

::v-deep .reinfo-tare .el-textarea__inner {
  width: 80%;
  border: none;
  font-size: 16px;
  padding: 0;
  resize: none;
}

.reinfo-uppic {
  border-bottom: 1px dotted #d8d8d8;
  margin-top: 20px;
  padding-bottom: 16px;
}

.reinfo-uptop {
  display: flex;
  align-items: center;
}

.reinfo-uptop i {
  width: 6px;
  color: #e2195c;
}

.reinfo-uptop span {
  width: 110px;
  font-size: 16px;
  color: #333;
  margin-left: 2px;
}

.reinfo-uptop b {
  font-size: 16px;
  color: #d8d8d8;
  font-weight: 400;
}

.picture-box {
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-left: 120px;
}

.picture-up {
  margin-right: 20px;
}

.picture-ever {
  display: flex;
  align-items: center;
}

.picture-list {
  position: relative;
  margin-right: 20px;
}

.picture-list img {
  width: 72px;
  height: 72px;
  border-radius: 6px;
}

.picture-list span {
  display: block;
  position: absolute;
  top: -8px;
  right: -9px;
  width: 18px;
  height: 18px;
  background: url(../../../public/images/gb.png) no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

.reinfo-but {
  display: flex;
  width: 440px;
  margin: 10px 0 0 120px;
}

.reinfo-close {
  width: 200px;
  height: 36px;
  background: #d8d8d8;
  border-radius: 18px;
  font-size: 18px;
  color: #333333;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
}

.reinfo-ok {
  width: 200px;
  height: 36px;
  background: linear-gradient(139deg, #ed403c 0%, #d71e1c 100%), #d8d8d8;
  border-radius: 18px;
  font-size: 18px;
  color: #fff;
  line-height: 36px;
  margin-left: 20px;
  text-align: center;
  cursor: pointer;
}

.bordnone {
  border-bottom: none;
}
</style>